export type SdCardGeneration = 'p28' | 'p3' | 'p32' | 'p5';

export type SdCardContainerExtension = 'psdat' | 'pdat' | 'pvdat' | 'pldat';

export type SdCardEntry = {
  /** POSIX path relative to the picked folder (forward slashes, no leading slash). */
  path: string;
  file: File;
};

/** A non-fatal advisory surfaced after a successful pack (e.g. reduced pTS compatibility). */
export type PackWarning = { title: string; description: string };

export type PackedArchive = {
  file: File;
  generation: SdCardGeneration;
  containerExtension: SdCardContainerExtension;
  warnings: PackWarning[];
};

export class SdCardError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'SdCardError';
  }
}

export const isSdCardError = (error: unknown): error is SdCardError =>
  error instanceof SdCardError;
